import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class TeacherDataService {
	public constructor(
		private api: ApiService
	) {}

	// CRUD
	public list = () => this.api.sendApiRequest('get', 'teacher/datatables').toPromise();
	public create = (data: any) => this.api.sendApiRequest('post', 'teacher', data).toPromise();
	public view = (id: string|number) => this.api.sendApiRequest('get', `teacher/${id}`).toPromise();
	public edit = (id: string|number, data: any) => this.api.sendApiRequest('put', `teacher/${id}`, data).toPromise();
	
	public delete = (id: string|number) => this.api.sendApiRequest('delete', `teacher/${id}`).toPromise();
}


// WEBPACK FOOTER //
// ./src/services/data.teachers.service.ts